<h2 class="mb-3">Event registration</h2>
<p class="light mb-4">Please provide your details below</p>
<div class="form-width">
  <app-collapsible [title]="'General information'" [index]="1" [expanded]="openStates.general">
    <div class="mt-3 mb-3" hiddenContent>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <app-input [fc]="innerForm.get('general.first_name')"
                       [label]="'First Name'"
            ></app-input>
          </div>
          <div class="col-md-6">
            <app-input [fc]="innerForm.get('general.last_name')"
                       [label]="'Last Name'"
            ></app-input>
          </div>
          <div class="col-md-6">
            <app-select [fc]="innerForm.get('general.gender')"
                        [options]="genderOptions"
                        [label]="'Gender'"
                        class="mb-3"
            ></app-select>
          </div>
          <div class="col-md-6">
            <app-input [fc]="innerForm.get('general.year_of_birth')"
                       [label]="'Year of birth'"
            ></app-input>
          </div>
          <div class="col-md-12">
            <app-input [fc]="innerForm.get('general.email')"
                       [label]="'Email'"
            ></app-input>
          </div>
          <div class="col-md-12">
            <app-tel-input [fc]="innerForm.get('general.phone')"
                           label="Phone number"
            ></app-tel-input>
          </div>
        </div>
      </div>
    </div>
  </app-collapsible>
</div>

<div class="form-width mt-3">
  <app-collapsible [title]="'Race details'" [index]="2" [expanded]="openStates.race_details">
    <div class="col-md-12 mt-3 mb-3" hiddenContent>
      <div class="row">
        <div class="col-md-6">
          <app-input [fc]="innerForm.get('race_details.team')"
                     [label]="'Team name'"
          ></app-input>
        </div>
        <div class="col-md-6">
          <app-select [fc]="innerForm.get('race_details.group')"
                      [options]="groupOptions"
                      [label]="'Group'"
                      class="mb-3"
          ></app-select>
        </div>
        <div class="col-md-12">
          <app-input [fc]="innerForm.get('race_details.licenceUrl')"
                     [label]="'Link to licence'"
          ></app-input>
        </div>
      </div>
    </div>
  </app-collapsible>
</div>

<div class="form-width mt-3 mb-5">
  <div class="mb-3">
    <app-klix-banner></app-klix-banner>
  </div>

  <app-button [submit]="true" [disabled]="innerForm.invalid" (click)="register()">
    Register & Pay
  </app-button>
</div>
